/* Three Oh Six — Cart-Drawer-Upsell "Complete the Set"
   Delegierter Submit-Handler (überlebt die innerHTML-Swaps des Drawers).
   Add via cart/add.js, danach cart:refresh (bewährtes Complete-Set-Muster). */
(function () {
  if (window.TOSCartUpsell) return;
  window.TOSCartUpsell = true;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cart-upsell-form]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: new FormData(form),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        btn.textContent = '✓';
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {
        btn.textContent = '✕';
        window.setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 2000);
      });
  });
})();
